import React, { useState, useEffect } from 'react';
import { useAuth } from '../contexts/AuthContext';
import guardianEmailPreferencesService from '../services/guardianEmailPreferencesService';
import { toast } from 'react-toastify';
import styles from '../assets/guardianEmailPreferences.module.css';

const GuardianEmailPreferences = () => {
  const { user } = useAuth();
  const [preferences, setPreferences] = useState({
    emails_receive_marketing: 0,
    emails_updates_by: 0,
    emails_share_data_other_organisations: 0,
  });
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    fetchEmailPreferences();
  }, []);

  const fetchEmailPreferences = async () => {
    try {
      setLoading(true);
      const data = await guardianEmailPreferencesService.getEmailPreferences();
      setPreferences(data);
    } catch (error) {
      console.error('Error fetching email preferences:', error);
      toast.error('Failed to load email preferences');
    } finally {
      setLoading(false);
    }
  };

  const handleRadioChange = (field, value) => {
    setPreferences((prev) => ({
      ...prev,
      [field]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      setSaving(true);
      await guardianEmailPreferencesService.updateEmailPreferences(preferences);
      toast.success('Email preferences updated successfully');
    } catch (error) {
      console.error('Error updating email preferences:', error);
      toast.error('Failed to update email preferences');
    } finally {
      setSaving(false);
    }
  };

  if (loading) {
    return (
      <div className={styles.container}>
        <div className={styles.loading}>Loading email preferences...</div>
      </div>
    );
  }

  return (
    <div className={styles.container}>
      <div className={styles.breadcrumb}>Edit my email preferences</div>

      <div className={styles.content}>
        <div className={styles.formSection}>
          <h2 className={styles.title}>Edit my email preferences</h2>

          <form onSubmit={handleSubmit} className={styles.form}>
            {/* Promotional Offers Section */}
            <div className={styles.questionGroup}>
              <p className={styles.questionText}>
                I agree that I would like to receive promotional offers,
                available property lists and other updates from Global Guardians
              </p>
              <div className={styles.radioGroup}>
                <label className={styles.radioLabel}>
                  <input
                    type="radio"
                    name="emails_receive_marketing"
                    value="0"
                    checked={preferences.emails_receive_marketing === 0}
                    onChange={(e) =>
                      handleRadioChange('emails_receive_marketing', parseInt(e.target.value))
                    }
                    className={styles.radioInput}
                  />
                  <span className={styles.radioCustom}></span>
                  No
                </label>
                <label className={styles.radioLabel}>
                  <input
                    type="radio"
                    name="emails_receive_marketing"
                    value="1"
                    checked={preferences.emails_receive_marketing === 1}
                    onChange={(e) =>
                      handleRadioChange('emails_receive_marketing', parseInt(e.target.value))
                    }
                    className={styles.radioInput}
                  />
                  <span className={styles.radioCustom}></span>
                  Yes
                </label>
              </div>
            </div>

            {/* Communication Method Section */}
            <div className={styles.questionGroup}>
              <p className={styles.questionText}>
                I would like to receive Global Guardians updates by:
              </p>
              <div className={styles.radioGroup}>
                <label className={styles.radioLabel}>
                  <input
                    type="radio"
                    name="emails_updates_by"
                    value="0"
                    checked={preferences.emails_updates_by === 0}
                    onChange={(e) =>
                      handleRadioChange('emails_updates_by', parseInt(e.target.value))
                    }
                    className={styles.radioInput}
                  />
                  <span className={styles.radioCustom}></span>
                  E-mail
                </label>
                <label className={styles.radioLabel}>
                  <input
                    type="radio"
                    name="emails_updates_by"
                    value="1"
                    checked={preferences.emails_updates_by === 1}
                    onChange={(e) =>
                      handleRadioChange('emails_updates_by', parseInt(e.target.value))
                    }
                    className={styles.radioInput}
                  />
                  <span className={styles.radioCustom}></span>
                  Phone
                </label>
                <label className={styles.radioLabel}>
                  <input
                    type="radio"
                    name="emails_updates_by"
                    value="2"
                    checked={preferences.emails_updates_by === 2}
                    onChange={(e) =>
                      handleRadioChange('emails_updates_by', parseInt(e.target.value))
                    }
                    className={styles.radioInput}
                  />
                  <span className={styles.radioCustom}></span>
                  Letter
                </label>
              </div>
            </div>

            {/* Contact Information Sharing Section */}
            <div className={styles.questionGroup}>
              <p className={styles.questionText}>
                I agree that Global Guardians can share my contact information
                with other organisations
              </p>
              <div className={styles.radioGroup}>
                <label className={styles.radioLabel}>
                  <input
                    type="radio"
                    name="emails_share_data_other_organisations"
                    value="0"
                    checked={preferences.emails_share_data_other_organisations === 0}
                    onChange={(e) =>
                      handleRadioChange('emails_share_data_other_organisations', parseInt(e.target.value))
                    }
                    className={styles.radioInput}
                  />
                  <span className={styles.radioCustom}></span>
                  No
                </label>
                <label className={styles.radioLabel}>
                  <input
                    type="radio"
                    name="emails_share_data_other_organisations"
                    value="1"
                    checked={preferences.emails_share_data_other_organisations === 1}
                    onChange={(e) =>
                      handleRadioChange('emails_share_data_other_organisations', parseInt(e.target.value))
                    }
                    className={styles.radioInput}
                  />
                  <span className={styles.radioCustom}></span>
                  Yes
                </label>
              </div>
            </div>

            {/* Save Button */}
            <div className={styles.buttonContainer}>
              <button
                type="submit"
                className={styles.saveButton}
                disabled={saving}
              >
                {saving ? 'Saving...' : 'Save'}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default GuardianEmailPreferences;
